export const LISTING_DOCUMENTS_HELP_LINK =
  'https://support.side.com/hc/en-us/sections/27131512059028-Working-on-Listings';

export const SIDE_STACK = 'https://marketplace.side.com/';
